module.exports = __webpack_public_path__ + "static/GorditaLight-c33b82dea32c974cc6f48c8cd433c132.woff2";